/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaPendingTag/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import Tysiav2WarningIcon from 'DesignSystem/Svgs/Tysiav2WarningIcon/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaPendingTag({
  children,
  viewPath = "/DesignSystem/TysiaPendingTag",
  reference,
  onMouseEnter,
  onMouseLeave,
  marginLeft,
  fill2,
  hovered,
  floating,
  left,
  top,
  text = "This feature is in progress. We will release it soon."
  
}) {
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
  return (<React.Fragment
>
<div
  data-testid="TysiaPendingTag.Vertical"
  data-view-path={viewPath}
 ref={reference}
 onMouseEnter={onMouseEnter}
 onMouseLeave={onMouseLeave}
 style={{'--ml-1-ZUCQbK': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft}}
 className={`views-block ${styles.Vertical}`}
>
<Tysiav2WarningIcon
  viewPath={`${viewPath}/Tysiav2WarningIcon`}
 fill2={fill2}
/>
</div>
<fromFlow.When is={hovered}>
<div
  data-testid="TysiaPendingTag.Vertical:1"
  data-view-path={viewPath}
 ref={floating}
 style={{'--l-2-ZUCQbK': typeof left === 'number' ? `${left}px` : left,'--t-3-ZUCQbK': typeof top === 'number' ? `${top}px` : top,'--bc-4-ZUCQbK': dtColorsWhite,'--bc-5-ZUCQbK': dtColorsNeutral200,'--btlr-6-ZUCQbK': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btrr-7-ZUCQbK': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bblr-8-ZUCQbK': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bbrr-9-ZUCQbK': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pb-10-ZUCQbK': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pt-11-ZUCQbK': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pl-12-ZUCQbK': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pr-13-ZUCQbK': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs}}
 className={`views-block new-shadow ${styles.Vertical1}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral500}
 text={text}
/>
</div>
</fromFlow.When>
{children}
</React.Fragment>)
}